// extracted by mini-css-extract-plugin
module.exports = {"bannerTitles":"HeroBannerSecondaryLinesTitles_bannerTitles__xhJ8g","title":"HeroBannerSecondaryLinesTitles_title__Xa3b0"};